<template>
  <div  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      style="height:50vh;overflow-y: scroll;"
      class="demo-ruleForm"
    >
      <el-form-item label="姓名：" prop="name">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.name"
          placeholder="请输入姓名"
          size="small"
          :maxlength="18"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="性别：" prop="sex">
        <el-select
          style="width:95%"
          v-model="ruleForm.sex"
          size="small"
          placeholder="请选择性别"
        >
          <el-option
            v-for="item in personnelSex"
            :key="item.id"
            :label="item.nameOne"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系方式：" prop="securityPhone">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.securityPhone"
          placeholder="请输入联系方式"
          size="small"
          :maxlength="24"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="身份证号：">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.idCard"
          placeholder="请输入身份证号"
          size="small"
          :maxlength="18"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="出生日期：">
        <el-date-picker
          style="width:95%"
          size="small"
          v-model="ruleForm.birthday"
          :editable="false"
          type="date"
          :picker-options="pickerOptions"
          @change="selectedAddDataDate"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="请选择出生日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="年龄：">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.age"
          placeholder="请选择出生日期自动计算"
          size="small"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="人员类型：">
        <el-select
          style="width:95%"
          v-model="ruleForm.employType"
          size="small"
          placeholder="请选择人员类型"
        >
          <el-option
            v-for="item in personnelType"
            :key="item.id"
            :label="item.nameOne"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属机构：" prop="securityCompany">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.securityCompany"
          placeholder="请输入所属机构"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="头像:">
        <head-portrait-up-load
          :imageUrl="ruleForm.img"
          @imageChange="imageChange"
        ></head-portrait-up-load>
      </el-form-item>
      <el-form-item label="负责人姓名：" prop="chargeName">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.chargeName"
          placeholder="请输入负责人姓名"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="负责人电话：" prop="chargePhone">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.chargePhone"
          placeholder="请输入负责人电话"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="负责人职务：">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.chargeJob"
          placeholder="请输入负责人职务"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
     
    </el-form>
    <div style="text-align:right">
      <span slot="footer" size="large">
        <el-button type="primary" size="small" @click="saveSubmit('ruleForm')"
          >提交</el-button
        >
        <el-button
          type="primary"
          size="small"
          plain
          @click="cencelSubmit('ruleForm')"
          >取消</el-button
        >
      </span>
    </div>
     
  </div>
</template>
<script>
import HeadPortraitUpLoad from "@/components/HeadPortraitUpLoad";
export default {
  name: "SecurityAddOrEdit",
  components: {
    HeadPortraitUpLoad
  },
  props: {
    defaultData: {
      type: Object,
      default: {
        return: {}
      }
    },
    showBox: {
      type: Boolean,
      default: {
        return: false
      }
    }
  },
  computed: {
    personnelSex() {
      return this.$store.state.select.personnelSex;
    },
    personnelType() {
      return this.$store.state.select.personnelType;
    }
  },
  data() {
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!reg.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      ruleForm: this.defaultData,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      rules: {
        name: [{ required: true, message: " ", trigger: "blur" }],
        sex: [{ required: true, message: " ", trigger: "change" }],
        chargeName: [{ required: true, message: " ", trigger: "blur" }],
        securityPhone: [{ required: true, message: " ", trigger: "blur" }],
        securityCompany: [{ required: true, message: " ", trigger: "blur" }],
        chargePhone: [
          { required: true, validator: checkPhone, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    selectedAddDataDate() {
      this.ruleForm.age = this.ruleForm.birthday ? this.$Common.calculationAges(this.ruleForm.birthday) : ''
    },
    imageChange(src) {
      this.ruleForm.img = src || "";
    },
    //   提交
    saveSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("saveSubmit", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    //   取消
    cencelSubmit(formName) {
      this.$refs[formName].resetFields();
      this.$emit("cencelSubmit");
    }
  },
  watch: {
    showBox: function(val) {
      this.$refs.ruleForm.resetFields();
      if (val) {
        this.ruleForm = Object.assign({}, this.defaultData);
      } else {
        this.$refs.ruleForm.resetFields();
      }
    }
  }
};
</script>
